<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title">Servicio Complementario</span>
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form
            class="form"
            [formGroup]="formAgregarServicioComp"
            autocomplete="off"
        >
            <mat-form-field class="full-width">
                <mat-label>Sucursal</mat-label>
                <mat-select
                    required
                    formControlName="sucursal"
                    (selectionChange)="puedeCotizar($event)"
                >
                    <mat-option
                        *ngFor="let sucursal of data.sucursales"
                        [value]="sucursal.id"
                    >
                        {{ sucursal.nombre }} - {{ sucursal.direccion }},
                        {{ sucursal.comuna.nombre }}
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="sucursal.hasError('required')">
                    Debe seleccionar la sucursal
                </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
                <mat-label>Observaciones</mat-label>
                <textarea
                    matInput
                    formControlName="observacion"
                    required
                    rows="3"
                    placeholder="Indique una descripción acerca del servicio que requiere"
                ></textarea>
                <mat-hint
                    >{{ observacion.value?.length }} /
                    {{ largoMaximo }}</mat-hint
                >
                <mat-error *ngIf="observacion.hasError('required')">
                    Debe ingresar la descripción del servicio
                </mat-error>
                <mat-error *ngIf="observacion.hasError('minlength')">
                    Debe ingresar al menos
                    {{ observacion.getError("minlength").requiredLength }}
                    caracteres
                </mat-error>
                <mat-error *ngIf="observacion.hasError('maxlength')">
                    Máximo
                    {{ observacion.getError("maxlength").requiredLength }}
                    caracteres
                </mat-error>
            </mat-form-field>

            <div class="file-uploader">
                <input
                    hidden
                    type="file"
                    #fileInput
                    formControlName="archivo"
                    (change)="getFile($event.target.files)"
                />
                <button
                    *ngIf="archivo && !archivo.value"
                    mat-button
                    color="primary"
                    class="add-file-button"
                    (click)="fileInput.click()"
                    aria-label="Adjuntar archivo"
                    [@animate]="{
                        value: '*',
                        params: { delay: '300ms', scale: '0.2' }
                    }"
                >
                    <mat-icon>note_add</mat-icon>

                    Adjuntar archivo
                </button>

                <button
                    mat-button
                    *ngIf="archivo && archivo.value"
                    (click)="archivo.setValue(null)"
                    aria-label="Eliminar archivo"
                    [@animate]="{
                        value: '*',
                        params: { delay: '300ms', scale: '0.2' }
                    }"
                >
                    <small>{{ archivo.value }}</small>
                    <mat-icon color="warn">delete_forever</mat-icon>
                </button>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            (click)="guardar()"
            [disabled]="!formAgregarServicioComp.valid"
        >
            Agregar
        </button>
    </mat-dialog-actions>
</div>
